module.exports = __webpack_public_path__ + "img/66.c12e137f.png";